import smoothscroll from "smoothscroll-polyfill";
import LazyDisp from "./lazydisp";
import ScrollDir from "./scrollDir";

const [w,d,l] = [window,document,location];

export default class INIT {
  constructor() {
    // Promiseオブジェクトを生成、実行
    this.promises = {
      init: new Promise((resolve) => this.initResolver = resolve),
      domReady: new Promise((resolve) => {
        d.addEventListener('DOMContentLoaded', () => {
          this.domReady();
          resolve(this);
        }, {once: true});
      }),
      windowLoad: new Promise((resolve) => {
        w.addEventListener('load', () => {
          this.windowLoad();
          resolve(this);
        }, {once: true});
      }),
    };

    // スクロール方向を判定するインスタンス
    this.ScrollDir = new ScrollDir();
  }

  init() {
    // initの解決
    this.initResolver(this);
  }
  
  domReady() {
    // LazyDisp開始
    this.LazyDisp = new LazyDisp('[data-lazydisp]');

    // pagetopなどhashスクロール
    this.hashscroll();
  }

  windowLoad() {
  }

  promiseAll() {
    return Promise.all( Object.values(this.promises) );
  }

  hashscroll(top = 0) {
    smoothscroll.polyfill();
    let pagetopHash = '#pagetop';
    let mq = w.matchMedia('(max-width:989px)');
    // pagetopハッシュの処理
    const scroll = () => {
      if( !l.hash ) return;
      if( l.hash === pagetopHash ) {
        w.history.replaceState(null, '', l.pathname + l.search);
      }else{
        const targetElement = d.querySelector(l.hash);
        const headerElement = d.querySelector('header.section-header');
        // 画面上部から要素までの距離
        const rectTop = (targetElement)? targetElement.getBoundingClientRect().top : 0;
        // スクロール位置に持たせるバッファ
        const buffer = (mq.matches)? headerElement.offsetHeight : 0;
        top = rectTop + w.pageYOffset - buffer;
      }
      w.scrollTo({ top, behavior: 'smooth' });
    }
    scroll();
    w.addEventListener('hashchange', scroll );
  }

}